import { render, staticRenderFns } from "./modal-confirm.component.vue?vue&type=template&id=5f690292&scoped=true&"
import script from "./modal-confirm.component.vue?vue&type=script&lang=ts&"
export * from "./modal-confirm.component.vue?vue&type=script&lang=ts&"
import style0 from "./modal-confirm.component.vue?vue&type=style&index=0&id=5f690292&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f690292",
  null
  
)

export default component.exports